export const environment = {
  production: false,
  stripePublishableKey:
    'pk_test_51IeFI9J9MkXumCy5J09QAlR8pJ0CVw4lobslTheAMlupHP4JiG1Dzg5OzzWAyMyF46FRHufZDo2AsZ2alPGKSuhW00BC0LqHJL',
  productFruitsWorkspaceCode: 'vnAN3OLRagocq7bb',
  brand: {
    attribution: 'Created by',
    showHelpCenter: true,
    title: 'Taikun',
  },
  sendAnalytics: false,
};
